// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import { cn } from '@/assets/lang/zh-cn'
import { en } from '@/assets/lang/en'
import { wxShareReady } from '@/utils/wxshare'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import enlang from 'element-ui/lib/locale/lang/en'
import cnlang from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

import '@/assets/plugins/font-awesome/css/font-awesome.min.css'
import '@/assets/plugins/bootstrap/css/bootstrap.min.css'
import '@/assets/corporate/css/style.css'
import '@/assets/corporate/css/style-responsive.css'
import '@/assets/corporate/css/themes/red.css'
import '@/assets/pages/css/components.css'
import '@/assets/plugins/uniform/css/uniform.default.css'
// import '@/assets/plugins/jquery.min.js'
import '@/assets/plugins/bootstrap/js/bootstrap.min.js'
import '@/assets/plugins/datetime-picker/bootstrap-datetimepicker.min.css'
import '@/assets/plugins/datetime-picker/bootstrap-datetimepicker.min.js'
import '@/assets/plugins/datetime-picker/bootstrap-datetimepicker.zh-CN.js'
import 'babel-polyfill'
import '@/assets/css/font.css'
import '@/assets/css/customs.css'

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(ElementUI)

const i18n = new VueI18n({
  locale: sessionStorage.lang || 'zh-cn',
  messages: { 'zh-cn': cn, 'en': en },
  silentTranslationWarn: true
})

locale.use(i18n.locale === 'en' ? enlang : cnlang) // 设置element语言

Vue.directive('share', {
  inserted: function(el, binding) {
    const title = binding.value.title
    const desc = binding.value.desc
    const link = binding.value.link
    const imgUrl = binding.value.imgUrl
    // document.title = binding.value.title || 'Beef to China'
    document.querySelector('meta[property="og:title"]').setAttribute('content', title)
    document.querySelector('meta[property="og:image"]').setAttribute('content', imgUrl)
    document.querySelector('meta[property="og:abstract"]').setAttribute('content', desc)
    document.querySelector('meta[property="og:url"]').setAttribute('content', link)
    wxShareReady(title, desc, link, imgUrl)
  }
})

Vue.filter('planno', function(item) {
  if (item === '') {
    return '--'
  } else {
    return item
  }
})

Vue.filter('quantity', function(item) {
  if (item === 0) {
    return '--'
  } else {
    return item
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js